import { Role } from '@/types/auth'
import { Log } from '@/types/logs'
import { checkIsLogUrgent } from './checkIsLogUrgent'
import { checkIsLogUnfinished } from './checkIsLogUnfinished'
import { useAuthStore } from '@/store/auth-store'

export const useCheckShouldHighlightRowAsUrgent = () => {
    const { role } = useAuthStore()

    const checkShouldHighlightRowAsUrgent = (log: Log) => {
        const isUrgent = checkIsLogUrgent(log)

        if (role === Role.Controller) {
            return isUrgent
        }
        return isUrgent || checkIsLogUnfinished(log)
    }

    return { checkShouldHighlightRowAsUrgent }
}
